import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from '@vc-workspace/utils-typography';
import { containerStyles, playStoreIcon } from './maker-floating-cta.module.style';
export function MakerFloatingCta() {
  return _jsxs("div", {
    css: containerStyles,
    children: [_jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      className: "text-center",
      bold: true,
      inline: true,
      children: "Download the app now!"
    }), _jsx("a", {
      target: "_blank",
      href: "https://play.google.com/store/apps/details?id=com.vibecity.merchantapp&referrer=utm_source=maker_page",
      css: playStoreIcon,
      rel: "noreferrer",
      children: _jsx("img", {
        src: "/_mp-images/play_store.png",
        alt: ""
      })
    })]
  });
}
export default MakerFloatingCta;